import { defineNuxtRouteMiddleware, navigateTo } from "#app";

import { useHost } from "~/shared/composables/useHost.ts";

export default defineNuxtRouteMiddleware((to) => {
  if (
    useHost().endsWith(".be") &&
    !to.path.startsWith("/nl") &&
    !to.path.startsWith("/fr")
  ) {
    // `/` → `/nl/` → nginx 301s again: strip the slash, one hop.
    return navigateTo(`/nl${to.path.replace(/\/$/, "")}`, {
      redirectCode: 301,
      replace: true,
    });
  }
});
